import { ArticleType } from "config/constants"
import { Guid, IHydratable, ITranslations } from "@/types"
import ReservationAsset, { IGetReservationAssetDto } from "./ReservationAsset"

export interface IGetReservationArticleDto {
    articleId: Guid
    colorId?: Guid | null
    quantity: number
    assets: IGetReservationAssetDto[]
}

export default class ReservationArticle implements IHydratable {
    articleId: Guid
    colorId?: Guid
    quantity: number
    assets: ReservationAsset[]

    articleNo?: string
    articleType?: ArticleType
    articleDescription?: string
    articleDescriptionTranslations?: ITranslations
    articleImageUri?: string
    articleThumbnailUri?: string
    articleFeatures?: ITranslations

    constructor(dto: IGetReservationArticleDto) {
        this.articleId = dto.articleId
        this.quantity = dto.quantity
        this.colorId = dto.colorId ?? undefined
        this.assets = dto.assets?.map(reservationAssetDto => new ReservationAsset(reservationAssetDto)) || undefined
    }

    get hasShortages(): boolean {
        return !!this.quantity
            && this.quantity > 0
            && !!this.assets?.find(asset => !asset.assetId)
    }

    get isAvailable(): boolean {
        return !this.hasShortages && !this.hasNotAvailableAssetWithUserAssignment
    }

    get hasAutomaticSelectionAssets(): boolean {
        return this.assets.some(asset => {
            return !!asset.assetId
                && !asset.hasUserAssignment
        })
    }

    get hasNotAvailableAssetWithUserAssignment(): boolean {
        return false
    }

    get hasUnplannedAsset(): boolean {
        return this.assets.some(a => a.unplanned)
    }

    get plannedAssetsCount(): number {
        return this.assets.filter(a => !a.unplanned).length
    }

    get isHydrated(): boolean {
        return !!this.articleNo || !!this.articleDescription
    }
}
